export default {
  action: 'יצוא',
  label: 'סוג קובץ',
};
